import {
	getWishlistProducts,
	isInWishlist,
	addToWishlist,
	removeFromWishList,
	onWishlistLoad
} from "../../core/helpers/swym";

import $ from "jquery";

const selectors = {
	wishlistButtons: "[data-add-to-wishlist]",
	wishlistButtonsPrevent: ".product-card__wishlist",
	header: "#shopify-section-header"
};

const modifiers = {
	hidden: "hidden",
	bodyHiddenHeader: "body-header-hidden",
	bodyStickyHeader: "body-header-sticky",
	showHeader: "animate",
	hiddenHeader: "shopify-section-header-hidden",
	wishlist: {
		added: "button--wishlist-added"
	}
};

async function getProductById(id) {
	const handle = (
		await fetch(
			`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`
		)
			.then((response) => response.json())
			.then((response) => response.resources.results.products.shift())
	).handle;

	return await fetch(`/products/${handle}.js`).then((response) =>
		response.json()
	);
}
$(document).on("boost:render_listing", initCollectionWishlist);
$(document).on("click", selectors.wishlistButtonsPrevent, (e) => {
	e.preventDefault();
	if (window.screen.width >= 1200) {
		if (
			$("body").hasClass(modifiers.bodyHiddenHeader) &&
			$("body").hasClass(modifiers.bodyStickyHeader)
		) {
			$(selectors.header).addClass(modifiers.showHeader);
			$(selectors.header).removeClass(modifiers.hiddenHeader);
		}
		e.preventDefault();
		const openWishlistEvent = new Event("openWishlistEvent");
		document.dispatchEvent(openWishlistEvent);
	}
});

function initCollectionWishlist() {
	const targetNode = document.querySelector(
		".boost-sd-container"
	);
	const config = { attributes: true, childList: true, subtree: true };
	const callback = function (mutationsList, observer) {
		let wishlistButtons = document.querySelectorAll(
			selectors.wishlistButtons
		);

		let boostSearchLayout = document.querySelector(
			".boost-sd-layout"
		);

		if (document.querySelector(".boost-sd-layout")) {
			boostSearchLayout = document.querySelector(".boost-sd-layout");
		}

		if (!wishlistButtons.length || boostSearchLayout === null) {
			return null;
		}

		onWishlistLoad(async function () {
			const wishlistProducts = await getWishlistProducts();
			const collectionVariants = [];
			const wishlistedVariants = [];

			for (const button of wishlistButtons) {
				button.classList.remove('hidden');
				collectionVariants.push(+button.dataset.wishlist);
			}

			for (const product of wishlistProducts) {
				wishlistedVariants.push(+product.wishlisted_variant_id);
			}

			for (let i = 0; i <= collectionVariants.length; i++) {
				if (wishlistedVariants.includes(collectionVariants[i])) {
					if (
						document.querySelector(
							`[data-wishlist-prod-id="${collectionVariants[i]}"]`
						) !== null
					) {
						document
							.querySelector(
								`[data-wishlist-prod-id="${collectionVariants[i]}"]`
							)
							.classList.add(modifiers.wishlist.added);
					} else {
						document
							.querySelector(
								`[data-wishlist="${collectionVariants[i]}"]`
							)
							.classList.add(modifiers.wishlist.added);
					}
				}
			}
		});
		for (const button of wishlistButtons) {
			$(button)
				.off()
				.on("click", function (e) {
					e.preventDefault();

					(async function () {
						const productId = +button.dataset.wishlistProdId;
						const variantId = +button.dataset.wishlist;

						const product = await getProductById(productId);
						const variant = product.variants.find(
							(variant) => variant.id === variantId
						);

						const addItemToWishlist = async () => {
							await addToWishlist(product, variant);

							const openWishlistEvent = new Event(
								"openWishlistEvent"
							);
							document.dispatchEvent(openWishlistEvent);

							return button.classList.add(
								modifiers.wishlist.added
							);
						};

						const removeItemFromWishlist = async () => {
							await removeFromWishList(product, variant);

							return button.classList.remove(
								modifiers.wishlist.added
							);
						};

						const isItemInWishlist = await isInWishlist(
							product,
							variant
						);

						if (isItemInWishlist) {
							await removeItemFromWishlist();
						} else {
							await addItemToWishlist();
						}
					})();
				});
		}

		observer.disconnect();
	};

	if (targetNode !== null) {
		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);
	}
}

export default initCollectionWishlist;
